import { Component } from '@angular/core';
import { CommunicationComponent } from '../communication/communication.component';

@Component({
    selector: 'political-negotiation',
    templateUrl: './political-negotiation.component.html',
    standalone: false
})
export class PoliticalNegotiationComponent extends CommunicationComponent {
  constructor () {
    super();
  }
};
